export default __webpack_public_path__ + "static/media/Arrow_left.314237e9.svg";